import {
  FETCH_USERS,
  RECEIVED_USERS,
  REQUESTED_USERS,
  REQUESTED_USERS_FAILED,
  REQUESTED_USERS_SUCCEEDED,
  FETCH_USER,
  RECEIVED_USER,
  REQUESTED_USER,
  REQUESTED_USER_FAILED,
  REQUESTED_USER_SUCCEEDED,
  LOGIN_USER,
  LOGOUT_USER,
  RESET_USER,
  MFA_REQUIRED,
  MFA_VERIFY,
  MFA_VERIFY_SUCCESS,
  MFA_VERIFY_FAILED,
  MFA_RESET,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILED,
  FORGOT_PASSWORD_RESET,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_RESET,
  UsersImpl,
  UserImpl,
  LoginImpl,
  UserFilter,
  MfaRequiredPayload,
  MfaVerifyPayload,
  ForgotPasswordPayload,
  ChangePasswordPayload,
} from './types'

/**
 * Notifies store that users are being fetched
 */
export const requestUsers = () => ({ type: REQUESTED_USERS })

/**
 * Notifies store that users fetch was a success
 */
export const requestUsersSuccess = () => ({ type: REQUESTED_USERS_SUCCEEDED })

/**
 * Notifies store that users fetch failed
 */
export const requestUsersError = () => ({ type: REQUESTED_USERS_FAILED })

/**
 * Sets received users to store
 */
export const receivedUsers = (data: UsersImpl) => ({
  type: RECEIVED_USERS,
  payload: data,
})

/**
 * Fetch
 */
export const getUsers = (filter: UserFilter = {}) => ({
  type: FETCH_USERS,
  payload: { filter },
})

/**
 * Notifies store that users are being fetched
 */
export const requestUser = () => ({ type: REQUESTED_USER })

/**
 * Notifies store that users fetch was a success
 */
export const requestUserSuccess = () => ({ type: REQUESTED_USER_SUCCEEDED })

/**
 * Notifies store that users fetch failed
 */
export const requestUserError = () => ({ type: REQUESTED_USER_FAILED })

/**
 * Sets received users to store
 */
export const receivedUser = (data: UserImpl) => ({
  type: RECEIVED_USER,
  payload: data,
})

/**
 * Loads current user details
 */
export const getUser = () => ({ type: FETCH_USER })

export const resetUser = () => ({ type: RESET_USER })

export const loginUser = (userLoginDetails: LoginImpl) => ({
  type: LOGIN_USER,
  payload: userLoginDetails,
})

export const logoutUser = (shouldCallAPI: Boolean) => ({
  type: LOGOUT_USER,
  payload: {
    shouldCallAPI,
  },
})

// MFA actions
export const mfaRequired = (payload: MfaRequiredPayload) => ({
  type: MFA_REQUIRED,
  payload,
})

export const mfaVerify = (payload: MfaVerifyPayload) => ({
  type: MFA_VERIFY,
  payload,
})

export const mfaVerifySuccess = () => ({
  type: MFA_VERIFY_SUCCESS,
})

export const mfaVerifyFailed = (error: string) => ({
  type: MFA_VERIFY_FAILED,
  payload: error,
})

export const mfaReset = () => ({
  type: MFA_RESET,
})

// Forgot password actions
export const forgotPasswordAction = (payload: ForgotPasswordPayload) => ({
  type: FORGOT_PASSWORD,
  payload,
})

export const forgotPasswordSuccess = () => ({
  type: FORGOT_PASSWORD_SUCCESS,
})

export const forgotPasswordFailed = (error: string) => ({
  type: FORGOT_PASSWORD_FAILED,
  payload: error,
})

export const forgotPasswordReset = () => ({
  type: FORGOT_PASSWORD_RESET,
})

// Change password actions
export const changePasswordAction = (payload: ChangePasswordPayload) => ({
  type: CHANGE_PASSWORD,
  payload,
})

export const changePasswordSuccess = () => ({
  type: CHANGE_PASSWORD_SUCCESS,
})

export const changePasswordFailed = (error: string) => ({
  type: CHANGE_PASSWORD_FAILED,
  payload: error,
})

export const changePasswordReset = () => ({
  type: CHANGE_PASSWORD_RESET,
})
